let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("88iU8")).then(() => parcelRequire('ls6D6'));